Registrable = require 'mixins/registrable'
HandleTextChange = require 'mixins/handle-text-change'

SmTextFieldComponent = Em.TextField.extend [
  Registrable
  HandleTextChange
]...,
  classNames: ['sm-text-field']

  setAutoFocus: (->
    @send('focus') if @get('autoFocus')
  ).on('didInsertElement')

  actions:
    focus: ->
      @$()?.focus()
      false

module.exports = App.SmTextFieldComponent = SmTextFieldComponent